(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('SummernoteModalController', [
        '$rootScope', 
        '$uibModalInstance', 
        '$timeout',
        'modalData',
        SummernoteModalControllerFn]);

    function SummernoteModalControllerFn(
        $rootScope, 
        $uibModalInstance, 
        $timeout,
        modalData
        ) {

        /* jshint validthis:true */
        var vm = this;
        vm.content = modalData.content || modalData.defaultContent;
        vm.title = modalData.title;
        vm.defaultContent = modalData.defaultContent;
        vm.showResetButton = modalData.showResetButton === true;
        vm.toolbar = $rootScope.isRingfoon ? 'full' : 'min';

        vm.save = function () {
            $uibModalInstance.close(vm.content);
        };

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        };

        vm.resetContent = function() {
            vm.content = vm.defaultContent;
        };
    }
})();
